import Api from '../../../../../../../shared/Api';
import { InvoiceReceiver } from '../view/InvoiceInformation';

export type InvoiceReceiverType = {
    value: InvoiceReceiver;
    type: number;
    displayName: string;
    allowsSeparateBillingAddress: boolean;
};

export type IInvoiceInformation = {
    invoiceReceiverType: InvoiceReceiverType;
    invoiceReceiverEmail: string;
    invoiceReceiverName: string;
    canEdit: boolean;
};

export class InvoiceSellerApi {
    static getInvoiceInformation(orderId: number): Promise<IInvoiceInformation> {
        return new Api().get(`/views/orders/${orderId}/basic-invoice-information`);
    }

    static saveReference(orderId: number, reference: string) {
        new Api().put(`/views/orders/${orderId}/basic-invoice-information/reference`, {
            reference
        });
    }
    
    static saveEmail(orderId: number, email: string) {
        new Api().put(`/views/orders/${orderId}/basic-invoice-information/email`, {
            email
        });
    }
}
